(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    function isBackForwardNavigation() {
      const navEntries = performance.getEntriesByType('navigation');
      return navEntries.length && navEntries[0].type === 'back_forward';
    }

    function restoreCollectionScrollPosition() {
      if (!isBackForwardNavigation()) return;

      let savedScrollY = null;

      try {
        savedScrollY = sessionStorage.getItem('collection-return-scroll-y');
      } catch (e) {}

      if (savedScrollY === null) return;

      const targetY = Number(savedScrollY);
      if (Number.isNaN(targetY)) return;

      let attempts = 0;
      const maxAttempts = 45;

      const tryRestore = () => {
        window.scrollTo({
          top: targetY,
          behavior: 'instant',
        });

        attempts += 1;

        if (attempts < maxAttempts) {
          requestAnimationFrame(tryRestore);
        } else {
          try {
            sessionStorage.removeItem('collection-return-scroll-y');
          } catch (e) {}
        }
      };

      requestAnimationFrame(() => {
        requestAnimationFrame(tryRestore);
      });
    }

    window.addEventListener('pageshow', restoreCollectionScrollPosition);
  })();

  } catch(e) { console.error(e); }
})();
})();
